import { render } from "./CustomerGroupPricingForZone.html?vue&type=template&id=ed476a72&scoped=true"
import script from "./CustomerGroupPricingForZone.js?vue&type=script&lang=js"
export * from "./CustomerGroupPricingForZone.js?vue&type=script&lang=js"

import "./CustomerGroupPricingForZone.css?vue&type=style&index=0&id=ed476a72&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed476a72"]])

export default __exports__